import { render } from "./Delivery.vue?vue&type=template&id=08e17eec"
const script = {}

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_c888307087c990cfda5c0d18ef320e2e/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/assets/icons/Delivery.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "08e17eec"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('08e17eec', __exports__)) {
    api.reload('08e17eec', __exports__)
  }
  
  module.hot.accept("./Delivery.vue?vue&type=template&id=08e17eec", () => {
    api.rerender('08e17eec', render)
  })

}


export default __exports__